<template>
  <WsMain>
    <WsCRUD
      v-if="isMounted"
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :showFields="showFields"
      :showExpand="false"
      :pageMode="true"
      :inRowBtnRead="true"
      :rowClickRead="true"
      :filterSelects="filterSelects"
      :filterProps="filterProps"
      @filter-select="$_onFilterSelect($event)"
      @set-modelDatas="$_onSetModelDatas"
    >
      <template v-slot:customBtns="{item}">
        <WsIconBtn
          tooltip="查看訂閱本法規之工廠清單"
          tooltipPosition="top"
          :to="`/act/${item.id}/subscribed_factories`"
          class="ml-1 mr-1"
        >mdi-factory</WsIconBtn>
      </template>
    </WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/act";
export default {
  data: () => ({
    isMounted: false,
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    filterSelects: [
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "area",
        paramName: "areas",
        placeholder: "請選擇地區",
      },
      {
        conditionKeys: [
          {
            fieldName: "areas",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "areas",
        label: "",
        type: "hasMany",
        textKey: "name",
        modelName: "area_section",
        placeholder: "請選擇子地區",
        hasNoSearch: true,
        hasAllSelectBtn: true,
      },
      {
        conditionKeys: [
          {
            fieldName: "areas",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "areas",
        type: "multiple-layer-select",
        label: "",
        textKey: "name",
        modelName: "system_subclasses",
        getUrl: "system_class",
        placeholder: " 領域",
        orderBy: "sequence",
        orderWay: "asc",
      },
      {
        conditionKeys: [
          {
            fieldName: "areas",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "areas",
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "act_type",
        placeholder: "篩選法規類別",
      },
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "admin",
        paramName: "updated_admin",
        placeholder: "最後更新人",
      },
      {
        type: "switch-tabs",
        label: "",
        textKey: "name",
        modelName: "is_active",
        defaultValue: "1",
        items: [
          {
            value: "1",
            text: "顯示",
          },
          {
            value: "0",
            text: "隱藏",
          },
        ],
      },
      {
        conditionKeys: [
          {
            fieldName: "areas",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "areas",
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "act_status",
        placeholder: "篩選法規狀態",
      },
      {
        type: "select",
        label: "",
        modelName: "act_idtf_status",
        placeholder: "篩選鑑別狀態",
        textKey: "name",
        items: [
          {
            text: "全部",
            value: "",
          },
          {
            text: "從未有鑑別",
            value: "1",
          },
          {
            text: "編輯草稿中",
            value: "2",
          },
          {
            text: "鑑別進行中",
            value: "3",
          },
          {
            text: "已完成鑑別",
            value: "4",
          },
        ],
        defaultValue: "",
      },
      {
        type: "select",
        modelName: "has_renew_version",
        placeholder: "篩選尚未更新至最新版本的法規",
        items: [
          {
            text: "全部",
            value: "",
          },
          {
            text: "無新版本可更新",
            value: "0",
          },
          {
            text: "有新版本可更新",
            value: "1",
          },
        ],
        defaultValue: "",
      },
      {
        type: "select",
        modelName: "has_failed_url",
        placeholder: "篩選來源連結異常",
        items: [
          {
            text: "全部",
            value: "",
          },
          {
            text: "無來源連結異常",
            value: "0",
          },
          {
            text: "有來源連結異常",
            value: "1",
          },
        ],
        defaultValue: "",
      },
      {
        type: "select",
        label: "",
        modelName: "range_type",
        placeholder: "篩選適用範圍類型",
        textKey: "name",
        items: [
          {
            text: "所有類型",
            value: "",
          },
          {
            text: "通用",
            value: "general",
          },
          {
            text: "專屬",
            value: "exclusive",
          },
        ],
        defaultValue: "",
      },
      {
        type: "hasMany",
        label: "",
        modelName: "factory",
        paramName: "exclusive_factories",
        placeholder: "篩選專屬工廠",
        textKey: "name",
        getText(item) {
          return this.$_CMS_getFactoryName(item);
        },
      },
      {
        type: "hasMany",
        label: "",
        modelName: "factory",
        paramName: "factories",
        placeholder: "篩選適用工廠",
        textKey: "name",
        getText(item) {
          return this.$_CMS_getFactoryName(item);
        },
      },
    ],
    filterProps: {},
    closeChipList: [
      {
        text: "apple13",
      },
      {
        text: "apple2",
      },
      {
        text: "apple3",
      },
    ],
    closeChipTitle: "篩選條件：",
    closeChipBackgroundColor: "#f7fafc",
    closeChipTextColor: "#353e4d",
    closeChipBorderColor: "#d7dee7",
    showFields: [
      "id",
      "sequence",
      "act_status",
      "act_idtf_status",
      "name",
      "act_type",
      "areas",
      "area_sections",
      "system_classes",
      "system_subclasses",
      "updated_at",
      "updated_admin",
    ],
  }),
  methods: {
    async $_filtersSet() {
      try {
        const res = await this.$axios.get("/system_class");
        res.data.data.forEach((systemClassItem) => {
          this.filterSelects[0].items.push({
            value: systemClassItem.id,
            text: systemClassItem.name,
          });
        });
        this.isMounted = true;
      } catch (error) {
        alert("領域取得錯誤");
      }
    },
    $_onFilterSelect($event) {
      if ($event && ($event.exclusive_factories || $event.factories)) {
        if (this.filterProps.range_type != $event.range_type) {
          if ($event.range_type === "exclusive") {
            this.filterProps = {
              ...$event,
              factories: null,
            };
          } else if ($event.range_type === "general") {
            this.filterProps = {
              ...$event,
              exclusive_factories: null,
            };
          } else if ($event.range_type === "") {
            this.filterProps = {
              ...$event,
              factories: null,
              exclusive_factories: null,
            };
          }
        } else {
          this.filterProps = {
            ...$event,
          };
        }
      } else {
        this.filterProps = {
          ...$event,
        };
      }
    },
    $_onSetModelDatas(rawDataList) {
      if (!Array.isArray(rawDataList)) return;
      rawDataList.forEach(rawData => {
        if (!rawData || !rawData.last_version || !rawData.last_version.act_idtf_assignment) {
          rawData.isInRowBtnUpdateDisabled = true;
          return;
        }
        rawData.isInRowBtnUpdateDisabled = rawData.last_version.act_idtf_assignment.status !== 3;
      });
    }
  },
  mounted() {
    // this.$_filtersSet();
    this.isMounted = true;
  },
};
</script>